<template>
  <b-card
    v-if="data"
    class="card-congratulation-medal"
  >
    <h5>Hello 🎉 {{ data.name }}!</h5>
    <b-card-text class="font-small-3">
      This is the main dashboard of your organization.
    </b-card-text>
    <h3 class="mb-75 mt-2 pt-50">
      <b-link :to="{ name: 'apps-order-list'}">
        {{ kFormatter(data.saleToday) }}
      </b-link>
    </h3>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      :to="{ name: 'apps-order-list'}"
    >
      View Orders
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { kFormatter } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    kFormatter,
  },
}
</script>
